class TeamMemberListing extends DrupalBehavior {

  onContent(context) {

    $('.team-member-listing .content-bottom .content-wrap', context).each(function(){
      $(this).find('.inner-wrap').matchHeight();
    });

    $('.provider-rating .rating', context).each(function(){
      let ratingNumber = $(this).attr('data-rating');
      let ratingWidth = $(this).width();
      let ratingPercentage = Math.floor((ratingNumber / 5) * 100);
      $(this).css('width', `${ratingWidth * (ratingPercentage * .01)}px`);
    });

    $('.team-member-listing .provider-teaser .content-left .video-modal', context).each(function(){
      var iframe = $(this).find('iframe');
      var url = iframe.attr('src');
      if (url.includes("http://")) {
          iframe.attr('src', url.replace("http://", "https://")); 
      }
    });

  }

}
  
  DrupalBehavior.register('guthrie_theme.components', 'team_member_listing', TeamMemberListing);